var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInvoicing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.001,
    height: 17.001,
    viewBox: "0 0 17.001 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.439,10.568c0,1.158-1.652,2.1-3.69,2.1s-3.69-.938-3.69-2.1,1.652-2.1,3.69-2.1,3.69.939,3.69,2.1Z",
    transform: "translate(-9.496 -4.221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.859,17.5c-2.639,0-3.69-1.106-3.69-1.747v2.745c0,1.158,1.652,2.1,3.69,2.1s3.692-.937,3.692-2.1V15.815c0,.642-1.052,1.681-3.692,1.681Z",
    transform: "translate(-9.551 -7.847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.859,25.957c-2.361,0-3.69-1.064-3.69-1.7v2.719c0,1.158,1.652,2.1,3.69,2.1s3.692-.938,3.692-2.1V24.219c0,.641-1.33,1.737-3.692,1.737Z",
    transform: "translate(-9.551 -12.067)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.366,2.1c0,1.158-1.873,2.1-4.183,2.1S0,3.254,0,2.1,1.873,0,4.183,0,8.366.939,8.366,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.448,9.025C1.457,9.025.265,7.919.265,7.278v2.745c0,1.158,1.873,2.1,4.183,2.1s4.184-.937,4.184-2.1V7.344C8.632,7.986,7.439,9.025,4.448,9.025Z",
    transform: "translate(-0.132 -3.626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.448,17.486c-2.676,0-4.183-1.063-4.183-1.7V18.5c0,1.158,1.873,2.1,4.183,2.1s4.184-.938,4.184-2.1V15.749C8.632,16.39,7.124,17.486,4.448,17.486Z",
    transform: "translate(-0.132 -7.847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.448,25.957c-2.676,0-4.183-1.064-4.183-1.7v2.719c0,1.158,1.873,2.1,4.183,2.1s4.184-.938,4.184-2.1V24.219c0,.641-1.509,1.737-4.184,1.737Z",
    transform: "translate(-0.132 -12.067)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvoicing);
export default __webpack_public_path__ + "static/media/IconInvoicing.dab46275643876566c0311f929f3a588.svg";
export { ForwardRef as ReactComponent };